// useInvestors.js
import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const fetchInvestors = async ({ pageParam = 1 }, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/invest/get-investors?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch investors');
  }

  return response.json();
};

const useInvestors = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ['investors'],
    ({ pageParam = 1 }) => fetchInvestors({ pageParam }, token),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalInvestors } = lastPage;
        const totalPages = Math.ceil(totalInvestors / 10); 
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    }
  );
};

export default useInvestors;









